export const site = {
  "product": "Sovasta Press",
  "packageName": "sovepress",
  "service": "sovepress",
  "domain": "press.sovetrust.com",
  "sections": [
    "overview",
    "desk",
    "review",
    "corrections",
    "community",
    "pricing",
    "support",
    "account"
  ],
  "labels": {
    "overview": "Overview",
    "desk": "News desk",
    "review": "Review",
    "corrections": "Corrections",
    "community": "Community",
    "pricing": "Pricing",
    "support": "Support",
    "account": "Account"
  },
  "kicker": "TRANSPARENT AI NEWSROOM · HUMAN EDITOR",
  "title": "Publish faster without hiding the editorial trail.",
  "body": "Sovasta Press is an AI-assisted newsroom where draft agents, review agents, and human editors produce explainable stories with sources, escalation, correction history, and reader trust built in.",
  "primary": "Open my newsroom",
  "secondary": "See review queue",
  "proof": "Draft agent · Review agent · Human approval",
  "onboarding": "Pick a beat, set an editorial risk level, and preview a transparent article workflow.",
  "demoTitle": "Editorial control room",
  "demoName": "Morning AI Policy Desk · Trust 91",
  "demoSignal": "Signal: 14 stories drafted, 5 escalated, 2 approved",
  "lines": [
    "Draft Agent creates a short source-backed article.",
    "Review Agent checks claims, tone, and missing evidence.",
    "Human Editor approves, escalates, or records a correction."
  ],
  "workspaceTitle": "Run a newsroom that shows its work.",
  "workspaceBody": "Define a beat, source policy, and escalation rule. Sovasta Press turns it into a daily desk with reviewable articles and correction logs.",
  "field1": "Newsroom name",
  "field2": "Beat",
  "field3": "Editorial promise",
  "default1": "AI Policy Briefing",
  "default2": "AI regulation and public trust",
  "default3": "No story publishes without source notes and correction path",
  "flowTitle": "Editorial pipeline",
  "cards": [
    "Draft story",
    "Review claims",
    "Approve or escalate",
    "Publish correction trail"
  ],
  "pricing": [
    [
      "Free",
      "$0",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Basic",
      "$9/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Pro",
      "$29/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Premium",
      "$99/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ]
  ],
  "supportPrompt": "Ask how to build a beat, configure review agents, handle corrections, or publish source-backed stories."
} as const;
